module.exports = __webpack_public_path__ + "img/appIcon-menu--Subscriptions--active.678dd22a.svg";